import { MouseEvent, useRef, useState } from 'react';
import { Text } from '@bendhealth/common';
import { CareIsFor } from 'components/account/account-setup.types';
import UpdateChildForm from 'components/account/update-child-form/UpdateChildForm';
import { FormProvider } from 'components/core/form';
import { FooterButton } from 'components/structure/footer/FooterButton';
import { FooterPortal } from 'components/structure/footer/FooterPortal';
import { CreateLeadValues, useCreateLead } from 'hooks/useCreateLead';
import { useNavigate } from 'react-router-dom';

import { FormProps } from '../account/UpdateChild';
import OnboardingTitle from '../components/OnboardingTitle';

const CreateNpMember = () => {
  const formRef = useRef<HTMLFormElement | null>(null);
  const { mutateAsync: createLead, isLoading, isError, error } = useCreateLead();
  const nav = useNavigate();
  const handleSubmit = (e: MouseEvent) => {
    e.preventDefault();

    formRef.current?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  };

  const handleContinue = async (isValid: boolean, values: FormProps) => {
    if (!isValid) {
      return;
    }
    const data: CreateLeadValues = {
      leadType: 'NP',
      memberFirstName: values.firstName,
      memberLastName: values.lastName,
      memberDateOfBirth: values.birthDate.toString(),
      memberPreferredName: values.nickname,
      memberSex: values.sex,
      memberGender: values.gender,
      memberPronouns: values.pronouns,
      memberEthnicity: values.raceEthnicity,
      memberStreetAddress1: values.street1,
      memberStreetAddress2: values.street2,
      memberCity: values.city,
      memberState: values.state,
      memberZipCode: values.zipCode.toString(),
      ayvaPharmacyUid: values.ayvaPharmacyUid?.toString(),
      pharmacyNcpdpId: values.pharmacyNcpdpId,
      hospitalizationFacility: values.hospitalizationFacility,
    };
    createLead(data)
      .then((lead) => {
        nav(`/np/members/${lead.memberId}/exclusions/`);
      })
      .catch((error) => {
        console.error('Error creating lead:', error);
      });
  };
  return (
    <>
      <OnboardingTitle
        title="Member Profile"
        subTitle={
          <>
            <Text variant="body-4">Tell us a bit more about who needs support: </Text>
          </>
        }
      />
      <FormProvider validateOnBlur onSubmit={handleContinue} controlRef={formRef}>
        <UpdateChildForm hideHospitalizationInfo patientId={undefined} careIsFor={CareIsFor.Child} />
        {isError && (
          <Text style={{ color: 'red' }} variant="body-4">
            {error instanceof Error ? error.message : 'Something went wrong'}
          </Text>
        )}
        <FooterPortal>
          <FooterButton onClick={handleSubmit} isLoading={isLoading}>
            Next
          </FooterButton>
        </FooterPortal>
      </FormProvider>
    </>
  );
};

export default CreateNpMember;
